import classNames from 'classnames';
import * as _ from 'lodash';
import { ReactNode } from 'react';

import { setupForDark } from '@theme';

interface CardButtonProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  text: string;
  icon?: ReactNode;
  disabled?: boolean;
  onClick: () => void;
}

function CardButton({ text, icon, disabled, onClick, className = '', ...rest }: CardButtonProps) {
  onClick = disabled ? _.noop : onClick;

  return (
    <div
      {...rest}
      className={classNames(
        'flex flex-col items-center gap-sm pt-xl pb-md px-md flex-stretch',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        disabled ? '' : setupForDark('hover:opacity-70'),
        'rounded-xs',
        setupForDark('text-secondary bg-card-secondary'),
        'border-[1px]',
        setupForDark('border-secondary'),
        'flex-1',
        disabled ? 'opacity-50' : 'opacity-100',
        className
      )}
      onClick={onClick}
    >
      {icon}
      <div className={classNames('P2M')}>{text}</div>
    </div>
  );
}

export default CardButton;
